import appService from '../js/appservice/index'
import funcs from '../js/helpers/misc'

const state = {
  scales: [],
  currentScale: {},
  currentScaleContent: {},
  currentScaleLanguageId: '',
  scalesError: '',
  isEditingScaleContent: false,
  questionCollection: []
}

const getters = {
  scales: state => state.scales,
  currentScale: state => state.currentScale,
  currentScaleContent: state => state.currentScaleContent,
  currentScaleLanguageId: state => state.currentScaleLanguageId,
  scalesError: state => state.scalesError,
  isEditingScaleContent: state => state.isEditingScaleContent,
  questionCollection: state => state.questionCollection
}

const actions = {
  getAllScales(context) {
    return new Promise(resolve => {
      appService.scales
        .getAllScales()
        .then(data => {
          context.commit('getAllScales', data)
          resolve({ ok: true })
        })
        .catch(error => {
          state.scalesError = error
          resolve({ ok: false })
        })
    })
  },
  selectCurrentScale(context, scale) {
    context.commit('selectCurrentScale', scale)
  },
  selectCurrentScaleContent(context, scaleContent) {
    context.commit('selectCurrentScaleContent', scaleContent)
  },
  setIsEditingScaleContent(context, value) {
    context.commit('setIsEditingScaleContent')
  },
  saveScaleDetails(context) {
    return new Promise((resolve, reject) => {
      // Scale does not exist
      if (!state.currentScale.id) {
        state.currentScale.contents = []
        if (state.currentScaleContent.languageId) {
          state.currentScale.contents.push(state.currentScaleContent)
        }

        appService.scales
          .addScale(state.currentScale)
          .then(data => {
            context.commit('addScale', data)
            resolve()
          })
          .catch(error => {
            state.scalesError = error.data
            reject(error.data)
          })
        // If a new content to be added
      } else if (
        !state.currentScaleContent.id &&
        state.currentScaleContent.languageId
      ) {
        appService.scales
          .addScaleContent(state.currentScale.id, state.currentScaleContent)
          .then(data => {
            context.commit('addScaleContent', data)
            resolve()
          })
          .catch(error => {
            state.scalesError = error.data
            reject(error.data)
          })
        // Scale content exists from before = update
      } else if (state.currentScaleContent.id) {
        appService.scales
          .updateScaleContent(state.currentScale.id, state.currentScaleContent)
          .then(data => {
            context.commit('updateScaleContent', data)
            resolve()
          })
          .catch(error => {
            state.scalesError = error.data
            reject(error.data)
          })
      } else {
        // Scale exists but no content... and no content will be added or updated
        appService.scales
          .updateScale(state.currentScale)
          .then(data => {
            context.commit('updateScale', data)
            resolve()
          })
          .catch(error => {
            state.scalesError = error.data
            reject(error.data)
          })
      }
    })
  },
  deleteScale(context) {
    return new Promise((resolve, reject) => {
      appService.scales
        .deleteScale(state.currentScale.id)
        .then(() => {
          context.commit('deleteScale', state.currentScale)
          resolve()
        })
        .catch(error => {
          state.scalesError = error.data
          reject(error.data)
        })
    })
  },
  deleteScaleContent(context, content) {
    return new Promise((resolve, reject) => {
      appService.scales
        .deleteScaleContent(state.currentScale.id, content.id)
        .then(() => {
          context.commit('deleteScaleContent', {
            scale: state.currentScale,
            scaleContent: content
          })
          resolve()
        })
        .catch(error => {
          state.scalesError = error.data
          reject(error.data)
        })
    })
  },
  getQuestions(context, indata) {
    return new Promise((resolve, reject) => {
      appService.scales
        .getQuestions(indata.scaleId, indata.languageId)
        .then(data => {
          context.commit('saveQuestions', data)
          resolve(data)
        })
        .catch(error => {
          state.scalesError = error
          reject(error)
        })
    })
  },
  saveQuestions(context, indata) {
    return new Promise((resolve, reject) => {
      appService.scales
        .saveQuestions(indata.scaleId, indata.data)
        .then(data => {
          context.commit('saveQuestions', data)
          resolve(data)
        })
        .catch(error => {
          state.scalesError = error
          reject(error)
        })
    })
  }
}

const mutations = {
  getAllScales(state, data) {
    state.scales = data
  },
  selectCurrentScale(state, data) {
    state.currentScale = data
  },
  selectCurrentScaleContent(state, data) {
    state.currentScaleContent = data
  },
  setIsEditingScaleContent(state, data) {
    state.isEditingScaleContent = data
  },
  addScale(state, data) {
    state.currentScale = data
    state.currentScaleContent = data.contents[0]
    state.scales.push(data)
  },
  updateScale(state, data) {
    state.currentScale = data
  },
  addScaleContent(state, data) {
    state.currentScale.contents.push(data)
  },
  updateScaleContent(state, data) {
    state.currentScaleContent = data
  },
  deleteScale(state, data) {
    var index = funcs.getIndexInCollection('id', data.id, state.scales)
    if (index !== -1) {
      state.scales.splice(index, 1)
    }
  },
  deleteScaleContent(state, data) {
    let content = data.scaleContent
    let scale = data.scale
    let index = funcs.getIndexInCollection('id', content.id, scale.contents)

    if (index !== -1) {
      scale.contents.splice(index, 1)
    }
  },
  saveQuestions(state, data) {
    state.questionCollection = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
